import { useContext, useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import "../../../styles/dashboard/transaction/transactionIndex.css";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import ExchangeCurrencyText from "../../../components/fragment/cur-text/ExchangeCurrencyText";
import TitleTextFragment from "../../../components/fragment/title-text/TitleTextFragment";
import {
  RazorBadgeTwo,
  RazorDateTime,
  RazorInputField,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
  RazorToolTip,
  RazorTwinValue,
} from "../../../components/razor-reuse";
import FilterReusableComp from "../../../components/FilterReusableComp";
import DotActionDropFragment from "../../../components/fragment/actionIconFragment/DotActionDropFragment";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import {
  getTransactionCount,
  getTransactions,
  getTransactionsCsv,
} from "../../../redux/transaction";
import Skeleton from "react-loading-skeleton";
import {
  AddAllToList,
  reactSelectStyleTable,
  rearrangeObjectsByKey,
} from "../../../utils/Helper";
import DateRangeComponent from "../../../components/fragment/date-range/DateRangeComponent";
import AmountRangeComponent from "../../../components/fragment/date-range/AmountRangeComponent";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { systemRoles } from "../../../utils/roles";
import ActionContext from "../../../context/ActionContext";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";

const BusinessTransactionIndex = () => {
  const actionCtx = useContext(ActionContext);
  const [filterOneVal, setFilterOneVal] = useState<any>("");
  const [filterTwoVal, setFilterTwoVal] = useState<any>("");
  const navigate = useNavigate();
  const { all_currencies_drop } = useSelector(
    (state: RootState) => state.settings
  );
  const { user } = useSelector((state: RootState) => state.auth);
  const { loading, transactions, transaction_count, loading_count } =
    useSelector((state: RootState) => state.transaction);
  const dispatch = useDispatch();

  const headerList = [
    "Sender’s Name",
    "Recipient’s Name",
    "Amount",
    // "TXN Reference",// Not needed for now due to long table content.
    "Currency EXR Type  ",
    "Date",
    "Status",
    "Action",
  ];

  const actionList = [
    {
      // icon: ALL_ICONS?.view,
      label: "View Transaction",
      onClick: (param?: any) => {
        localStorage?.setItem("cors_key", param?.id);
        navigate(ALL_ROUTES?.DASHBOARD_TRANSACTION_DETAILS + "?type=business");
      },
      textColor: "",
    },
  ];

  const selectListOne = [
    { label: "Successful", value: "successful" },
    // { label: "Completed", value: "completed" },
    { label: "Failed", value: "failed" },
    { label: "Pending", value: "pending" },
    { label: "Processing", value: "processing" },
    { label: "Refunded", value: "refunded" },
    { label: "Expired", value: "expired" },
    { label: "All status", value: "" },
  ];

  const [currencyView, setCurrencyView] = useState<any>({
    label: "All Currencies",
    value: "",
    donT_send: true,
  });
  const [currentPageVal, setCurrentPage] = useState(1);
  const [dateRange, setDateRange] = useState("");
  const [amountRange, setAmountRange] = useState("");
  const [search, setSearch] = useState("");

  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[11]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  const obj = {
    page: currentPageVal,
    search: search,
    status: filterOneVal?.value,
    currency_type: filterTwoVal?.value,
    date: dateRange,
    amount: amountRange,
    type: "business",
    per_page: actionCtx?.perPage?.label,
    currency: currencyView?.donT_send ? `` : currencyView?.value,
  };
  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[11])) {
      dispatch(getTransactions(obj) as any);
    }
  }, [
    currentPageVal,
    dateRange,
    filterOneVal,
    filterTwoVal,
    amountRange,
    dispatch,
    user?.permissions,
    actionCtx?.perPage,
    search,
  ]);

  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[11])) {
      dispatch(getTransactionCount(obj) as any);
    }
  }, [currencyView, dispatch, user?.permissions, amountRange, dateRange]);

  const formatDropDownOption = () => {
    const newList = transaction_count?.map((chi: any) => {
      const fromCur = chi?.source_currency_code;
      const toCur = chi?.destination_currency_code;
      return {
        ...chi,
        label: `${fromCur} - ${toCur}`,
        value: `${chi?.source_currency},${chi?.destination_currency}`,
        fromLabel: fromCur,
        toLabel: toCur,
        imageUrl: ``,
      };
    });
    const secondlist = newList?.filter(
      (chi: any) => chi?.status !== "inactive"
    );
    return AddAllToList(secondlist, "Currency Type");
  };

  const formatOptionLabel = ({ label, fromLabel, toLabel, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <ExchangeCurrencyText
            loading={loading_count}
            curOne={fromLabel || "NIL"}
            curTwo={toLabel || "NIL"}
            urlOne={
              fromLabel === "USD"
                ? ""
                : fromLabel === "EUR"
                ? ""
                : fromLabel === "GBP"
                ? ""
                : fromLabel === "NGN"
                ? ""
                : fromLabel === "CAD"
                ? ""
                : ""
            }
            urlTwo={
              toLabel === "USD"
                ? ""
                : toLabel === "EUR"
                ? ""
                : toLabel === "GBP"
                ? ""
                : toLabel === "NGN"
                ? ""
                : toLabel === "CAD"
                ? ""
                : ""
            }
          />
        </>
      );
    }
  };

  const formatOptionLabelOne = ({ label, value }: any) => {
    if (value === "") {
      return filterOneVal ? (
        <RazorBadgeTwo className={""} text={label} />
      ) : (
        label
      );
    } else {
      return (
        <>
          <RazorBadgeTwo
            className={
              value === "failed"
                ? "failed"
                : value === "successful"
                ? "success"
                : value === "completed"
                ? "success"
                : value === "pending"
                ? "pending"
                : value === "processing"
                ? "pending"
                : value === "submitted"
                ? "pending"
                : ""
            }
            text={label}
          />
        </>
      );
    }
  };

  const removeSelectedList = (list: any) => {
    if (list?.length > 0) {
      const newlist = list?.filter(
        (chi: any) => chi?.label !== filterOneVal?.label
      );
      const secondlist = newlist?.filter(
        (chi: any) => chi?.label !== filterTwoVal?.label
      );
      return secondlist;
    }
  };

  const formatOptionLabelCurrency = ({ label, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <CurrencyText currency={label} text={label} />
        </>
      );
    }
  };

  const formatCurrencyValList = (list: any) => {
    const newList = list?.filter(
      (chi: any) => chi?.label !== currencyView?.label
    );
    // const
    return newList;
  };

  return (
    <>
      <DashboardLayoutMain
        loading={loading && Object?.keys(transactions)?.length < 1}
        title="Transactions"
      >
        <div className="transaction-index-wrap-box-smartsend">
          <TitleBtnFragment
            selectFragment={
              <>
                {!loading_count && transaction_count?.length > 0 && (
                  <RazorInputField
                    selectOption={formatCurrencyValList(
                      AddAllToList(all_currencies_drop, "Currencies")
                    )}
                    type="select"
                    color="black-light"
                    className="select-title-wrap"
                    value={currencyView}
                    onChange={(e: any) => {
                      setCurrencyView(e);
                      setFilterTwoVal("");
                    }}
                    selectStyles={reactSelectStyleTable}
                    formatOptionLabel={formatOptionLabelCurrency}
                  />
                )}
                <div
                  onClick={() => {
                    dispatch(getTransactionsCsv(obj) as any);
                  }}
                  className="bg-white inline-flex items-center gap-x-[4px] py-[6px] px-[12px] rounded-xl border cursor-pointer"
                >
                  <figure className="size-fit">
                    {ALL_ICONS?.export_down_icon}
                  </figure>
                  <p className="font-normal ">Export</p>
                </div>
              </>
            }
            title="Total Transactions"
            hideBtn
          />
          {/* title btn end */}
          {/* card list start */}
          <div className="card-list-box">
            {rearrangeObjectsByKey("status", "active", transaction_count)?.map(
              (chi: any, idx: any) => {
                return (
                  <div
                    key={idx}
                    className={`card-box ${
                      chi?.status === "inactive" ? `card-box-inactive` : ""
                    }`}
                  >
                    <div className="title-box">
                      <ExchangeCurrencyText
                        loading={loading_count}
                        curOne={chi?.source_currency_code || "NIL"}
                        curTwo={chi?.destination_currency_code || "NIL"}
                        urlOne={
                          chi?.source_currency_code === "USD"
                            ? ""
                            : chi?.source_currency_code === "EUR"
                            ? ""
                            : chi?.source_currency_code === "GBP"
                            ? ""
                            : chi?.source_currency_code === "NGN"
                            ? ""
                            : chi?.source_currency_code === "CAD"
                            ? ""
                            : ""
                        }
                        urlTwo={
                          chi?.destination_currency_code === "USD"
                            ? ""
                            : chi?.destination_currency_code === "EUR"
                            ? ""
                            : chi?.destination_currency_code === "GBP"
                            ? ""
                            : chi?.destination_currency_code === "NGN"
                            ? ""
                            : chi?.destination_currency_code === "CAD"
                            ? ""
                            : ""
                        }
                      />
                      {/* {!loading_count && <p className="text"> Transaction</p>} */}
                    </div>
                    {/* end of title box */}
                    {/* count volume box start */}
                    {chi?.status === "inactive" ? (
                      <div className="inactive-box">
                        {!loading_count ? (
                          <RazorBadgeTwo className="pending" text="Pending" />
                        ) : (
                          <Skeleton
                            width={55}
                            height={20}
                            style={{ borderRadius: "1.2rem" }}
                          />
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="count-volume-box">
                          {loading_count ? (
                            <>
                              <div className="">
                                <Skeleton
                                  style={{ marginBottom: "2rem" }}
                                  width={50}
                                  height={12}
                                />
                                <Skeleton width={70} height={15} />
                              </div>
                            </>
                          ) : (
                            <TitleTextFragment
                              className="text-title-box"
                              titleColor="#596080"
                              titleSize="1.25rem"
                              textSize="2rem"
                              textColor="#191C1F"
                              title="Total  Count"
                              text={RazorNumberFormat(chi?.total_count, {
                                hideDecimal: true,
                                hideSymbol: true,
                                numberAbbreviate:
                                  String(chi?.total_count)?.length > 5,
                                // convertToNumber:
                              })}
                            />
                          )}
                          {/* label value text end */}
                          {/* label value text start */}
                          {loading_count ? (
                            <>
                              <div className="">
                                <Skeleton
                                  style={{ marginBottom: "2rem" }}
                                  width={50}
                                  height={12}
                                />
                                <Skeleton width={70} height={15} />
                              </div>
                            </>
                          ) : (
                            <div className="tooltip-hover-wrap">
                              {" "}
                              <TitleTextFragment
                                className="text-title-box"
                                titleColor="#596080"
                                titleSize="1.25rem"
                                textSize="2rem"
                                textColor="#191C1F"
                                title="Total Transactions"
                                text={RazorNumberFormat(
                                  chi?.total_transactions,
                                  {
                                    // numberAbbreviate:
                                    //   String(chi?.total_transactions)?.length >
                                    //   7,
                                    symbol: chi?.source_currency_code,
                                    // convertToNumber: true
                                  }
                                )}
                              />
                              {String(chi?.total_transactions)?.length > 6 && (
                                <RazorToolTip
                                  color="black-light"
                                  text={RazorNumberFormat(
                                    chi?.total_transactions,
                                    {
                                      symbol: chi?.source_currency_code,
                                      // convertToNumber: true
                                    }
                                  )}
                                  position={`top-center`}
                                />
                              )}
                            </div>
                          )}
                          {/* label value text end */}
                        </div>
                      </>
                    )}

                    {/* count volume box end */}
                  </div>
                );
              }
            )}
          </div>
          {/* card list end */}
          {/* filter section start */}
          <FilterReusableComp
            defaultSelectOne="Status"
            selectOneList={removeSelectedList(selectListOne)}
            selectOneValue={filterOneVal}
            onSelectOne={(param) => {
              setFilterOneVal(param);
            }}
            // formatOptionLabelOne={formatOptionLabelOne}
            defaultSelectTwo="Currency Type"
            selectTwoList={removeSelectedList(formatDropDownOption())}
            selectWidthTwo="20rem"
            selectTwoValue={filterTwoVal}
            onSelectTwo={(param) => {
              setFilterTwoVal(param);
              // console.log(param);
            }}
            formatOptionLabelTwo={formatOptionLabel}
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                setSearch(param);
              }
              if (String(param)?.length < 1) {
                setSearch("");
              }
            }}
            hideExport
            searchPlaceholder="Search for transaction"
            moreComponents={
              <>
                <DateRangeComponent
                  onSet={(param) => {
                    setDateRange(param);
                  }}
                  value={dateRange}
                  onCancel={() => {
                    setDateRange("");
                  }}
                  // onOpen={}
                />
                <AmountRangeComponent
                  onSet={(param) => {
                    setAmountRange(param);
                  }}
                  value={amountRange}
                  onCancel={() => {
                    setAmountRange("");
                  }}
                />
              </>
            }
          />
          {/* filter section end */}
          {/* table start */}
          <div className="table-section-box">
            <RazorTable headerList={headerList}>
              {transactions?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    key={idx}
                    one={
                      <RazorTwinValue
                        one={RazorTextTrim(
                          chi?.sender?.first_name
                            ? `${chi?.sender?.first_name} ${chi?.sender?.last_name}`
                            : chi?.sender?.account_name || "",
                          35
                        )}
                        two={`${RazorTextTrim(chi?.sender?.email, 30) || ""}`}
                      />
                    }
                    two={
                      <RazorTwinValue
                        one={RazorTextTrim(
                          chi?.beneficiary_details?.details?.account_name?.trim() ||
                            chi?.beneficiary_details?.account_name?.trim() ||
                            chi?.recipient_name?.trim() ||
                            "----",
                          35
                        )}
                        two={`${
                          RazorTextTrim(
                            chi?.beneficiary_details?.email ||
                              chi?.beneficiary_details?.details?.email ||
                              chi?.beneficiary_details?.details
                                ?.interac_email ||
                              chi?.beneficiary_details?.interac_email,
                            30
                          ) || ""
                        }`}
                      />
                    }
                    three={RazorNumberFormat(chi?.amount, {
                      hideSymbol: false,
                      symbol: chi?.source_currency?.code,
                    })}
                    // four={
                    //   <RazorCopyText
                    //     reference={chi?.tx_reference}
                    //     textToCopy={chi?.tx_reference}
                    //     outerCopy
                    //   />
                    // }
                    onRowClick={() => {
                      localStorage?.setItem("cors_key", chi?.id);
                      navigate(
                        ALL_ROUTES?.DASHBOARD_TRANSACTION_DETAILS +
                          "?type=business"
                      );
                    }}
                    four={
                      <ExchangeCurrencyText
                        curOne={chi?.source_currency?.code || "NIL"}
                        curTwo={chi?.destination_currency?.code || "NIL"}
                        urlOne={
                          chi?.source_currency?.code === "USD"
                            ? ""
                            : chi?.source_currency?.code === "EUR"
                            ? ""
                            : chi?.source_currency?.code === "GBP"
                            ? ""
                            : chi?.source_currency?.code === "NGN"
                            ? ""
                            : chi?.source_currency?.code === "CAD"
                            ? ""
                            : chi?.source_currency?.logo
                        }
                        urlTwo={
                          chi?.destination_currency?.code === "USD"
                            ? ""
                            : chi?.destination_currency?.code === "EUR"
                            ? ""
                            : chi?.destination_currency?.code === "GBP"
                            ? ""
                            : chi?.destination_currency?.code === "NGN"
                            ? ""
                            : chi?.destination_currency?.code === "CAD"
                            ? ""
                            : chi?.destination_currency?.logo
                        }
                      />
                    }
                    loading={loading}
                    five={<RazorDateTime date={chi?.created_at} />}
                    six={
                      <RazorBadgeTwo
                        className={
                          chi?.status === "failed"
                            ? "failed"
                            : chi?.status === "successful"
                            ? "success"
                            : chi?.status === "completed"
                            ? "success"
                            : chi?.status === "pending"
                            ? "pending"
                            : chi?.status === "processing"
                            ? "pending"
                            : chi?.status === "submitted"
                            ? "pending"
                            : ""
                        }
                        text={chi?.status}
                      />
                    }
                    seven={
                      <DotActionDropFragment list={actionList} detail={chi} />
                    }
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={transactions?.meta?.current_page || 1}
            perPage={transactions?.meta?.per_page}
            totalPage={transactions?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading}
            showPerPage
          />
          {/* pagination  end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default BusinessTransactionIndex;
